import styled from "styled-components";
import { ReactComponent as LinkIcon } from "assets/svg/link-alt.svg";
import { LinkIconContainer } from "Components/ArtistSubdomainModal";

export const ArtistImage = ({ imageUrl }: { imageUrl: string }) => (
  <ArtistImageContainer>
    <img src={imageUrl} alt="artist" />
    <StyledLinkIconContainer>
      <LinkIcon />
    </StyledLinkIconContainer>
  </ArtistImageContainer>
);

const ArtistImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  width: 50px;
  height: 50px;

  img {
    border-radius: 50%;
  }

  ${({ theme }) => theme.media.mobile} {
    width: 45px;
    height: 45px;
  }
`;

const StyledLinkIconContainer = styled(LinkIconContainer)`
  bottom: -2px;
`;
